<div class="toolbar">
  <p-button
    label="{{ 'QUERY.TITLE_NEW' | translate }}"
    icon="pi pi-plus"
    (click)="newRecord()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
  sortField="createdAt"
  [sortOrder]="-1"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25, 50, 100]"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="header-checkbox"></th>
      <th pSortableColumn="labType" id="header-lab-type">
        {{ "QUERY.LAB_TYPE" | translate }}
        <p-sortIcon field="labType"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="labType"
          matchMode="equals"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
          style="margin-left: 10px"
        >
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-dropdown
              [options]="labTypeFilterOptions"
              [ngModel]="value"
              (ngModelChange)="filter($event)"
              [placeholder]="'QUERY.LAB_TYPE' | translate"
              [showClear]="true"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            ></p-dropdown>
          </ng-template>
        </p-columnFilter>
      </th>
      <th pSortableColumn="title" id="header-title">
        {{ "TITLE" | translate }}<p-sortIcon field="title"></p-sortIcon>
        <p-columnFilter
          type="text"
          matchMode="contains"
          display="menu"
          field="title"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
          style="margin-left: 10px"
        ></p-columnFilter>
      </th>
      <th id="header-historic">
        {{ "QUERY.INCLUDE_HISTORICAL_DATA" | translate }}
      </th>
      <th id="header-demographic">
        {{ "QUERY.DEMOGRAPHIC_DATA_ONLY" | translate }}
      </th>
      <th pSortableColumn="createdAt" id="header-created-at">
        {{ "CREATED" | translate }} <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-search"
            (click)="onRowShow(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td>
        <span style="display: flex; align-items: center; gap: 0.5rem">
          <img
            [src]="getLabTypeIcon(record)"
            [alt]="getLabTypeTitle(record) | translate"
            [title]="getLabTypeTitle(record) | translate"
            style="width: 1.2rem; height: 1.2rem"
          />
          {{ getLabTypeTitle(record) | translate }}
        </span>
      </td>
      <td>{{ record.title }}</td>
      <td>
        <i
          [class]="
            hasHistoricData(record)
              ? 'pi pi-check-circle text-green-500'
              : 'pi pi-times-circle text-gray-400'
          "
          [title]="
            hasHistoricData(record)
              ? ('QUERY.INCLUDE_HISTORICAL_DATA' | translate)
              : ''
          "
        ></i>
      </td>
      <td>
        <i
          [class]="
            isDemographicDataOnly(record)
              ? 'pi pi-check-circle text-green-500'
              : 'pi pi-times-circle text-gray-400'
          "
          [title]="
            isDemographicDataOnly(record)
              ? ('QUERY.DEMOGRAPHIC_DATA_ONLY' | translate)
              : ''
          "
        ></i>
      </td>
      <td>{{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}</td>
    </tr>
  </ng-template>
</p-table>
